import { render } from "./AppVersionInfoM.vue?vue&type=template&id=4247a81e&scoped=true"
import script from "./AppVersionInfoM.vue?vue&type=script&lang=js"
export * from "./AppVersionInfoM.vue?vue&type=script&lang=js"

import "./AppVersionInfoM.vue?vue&type=style&index=0&id=4247a81e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4247a81e"]])

export default __exports__